import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star, Quote } from 'lucide-react';
export function BenefitsSection() {
  const benefits = ['Multiplicar tus plantas favoritas sin gastar en viveros', 'Saber exactamente qué hacer en cada etapa (sin improvisar)', 'Evitar los errores que matan el 80% de los esquejes', 'Tener plantas nuevas en 4-8 semanas (según la especie)', 'Aplicar el método a cualquier planta de tu casa o jardín', 'Dejar de perder tiempo buscando videos sueltos en internet'];
  const testimonials = [{
    text: 'Finalmente entendí por qué mis esquejes no prosperaban. Ahora tengo plantas para regalar.',
    author: 'Martín',
    location: 'Bogotá'
  }, {
    text: 'Pensé que era difícil, pero la guía lo hace súper simple. Hasta mi mamá lo está usando.',
    author: 'Lucía',
    location: 'Medellín'
  }, {
    text: 'Dejé de perder tiempo buscando en YouTube. Aquí está todo lo que necesito.',
    author: 'Diego',
    location: 'Cali'
  }];
  return <section className="py-20 bg-white" data-id="element-1">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        {/* Benefits Grid */}
        <div className="max-w-5xl mx-auto mb-24" data-id="element-3">
          <div className="text-center mb-16" data-id="element-4">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-5">
              Qué vas a lograr con esta guía
            </h2>
            <p className="text-xl text-gray-600" data-id="element-6">
              Resultados concretos que vas a ver en las próximas semanas
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-7">
            {benefits.map((benefit, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4 p-6 rounded-xl bg-[#fafaf9] border border-gray-100 hover:border-[#4a7c2c]/30 transition-colors" data-id="element-8">
                <div className="w-8 h-8 rounded-full bg-[#4a7c2c]/10 flex items-center justify-center flex-shrink-0 text-[#4a7c2c]" data-id="element-9">
                  <Check className="w-5 h-5" data-id="element-10" />
                </div>
                <p className="text-gray-800 font-medium" data-id="element-11">{benefit}</p>
              </motion.div>)}
          </div>
        </div>

        {/* Testimonials */}
        <div className="max-w-6xl mx-auto" data-id="element-12">
          <div className="grid md:grid-cols-3 gap-8" data-id="element-13">
            {testimonials.map((t, i) => <motion.div key={i} initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 relative" data-id="element-14">
                <Quote className="absolute top-6 right-6 w-8 h-8 text-[#4a7c2c]/10" data-id="element-15" />
                <div className="flex gap-1 mb-4" data-id="element-16">
                  {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-17" />)}
                </div>
                <p className="text-gray-700 mb-6 italic relative z-10" data-id="element-18">
                  "{t.text}"
                </p>
                <div className="flex items-center gap-3" data-id="element-19">
                  <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center text-gray-500 font-bold" data-id="element-20">
                    {t.author[0]}
                  </div>
                  <div data-id="element-21">
                    <p className="font-bold text-gray-900" data-id="element-22">{t.author}</p>
                    <p className="text-sm text-gray-500" data-id="element-23">{t.location}</p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}